import React, { useState, useEffect } from 'react';
//import dbHelpers from '../config/database';

import {
  Users,
  Briefcase,
  Mail,
  BarChart3,
  Plus,
  Edit,
  Trash2,
  Eye,
  EyeOff,
  Save,
  X,
  XCircle,
  Search,
  Filter,
  Download,
  Calendar,
  MapPin,
  DollarSign,
  Clock,
  CheckCircle,
  AlertCircle,
  UserPlus,
  Building,
  UserCheck,
  UserX,
  FileText,
  Receipt,
  Megaphone,
  ShieldCheck,
  ArrowRight,
  LayoutDashboard
} from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { dbHelpers } from '../config/database';
import { BillingManager } from './Billing/BillingManager';
import { SalesDashboard } from './Sales/SalesDashboard';
import { MarketingDashboard } from './Marketing/MarketingDashboard';
import { HRDashboardView } from './HR/HRDashboardView';
import { EmployeeDashboard } from './Employee/EmployeeDashboard';
import ClientDashboard from './Client/Client1';

const roleIdToLabel = (role_id: number | string): 'admin' | 'hr' | 'employee' | 'product_manager' | 'scrum_master' | 'client' | 'finance' | 'sales' | 'marketing' => {
  const rid = Number(role_id);
  if (rid === 1) return 'admin';
  if (rid === 2) return 'hr';
  if (rid === 4) return 'product_manager';
  if (rid === 5) return 'finance';
  if (rid === 6) return 'scrum_master';
  if (rid === 7) return 'client';
  if (rid === 8) return 'sales';
  if (rid === 9) return 'marketing';
  return 'employee';
};

const roleLabelToId = (role: 'admin' | 'hr' | 'employee' | 'product_manager' | 'scrum_master' | 'client' | 'finance' | 'sales' | 'marketing'): number => {
  if (role === 'admin') return 1;
  if (role === 'hr') return 2;
  if (role === 'product_manager') return 4;
  if (role === 'finance') return 5;
  if (role === 'scrum_master') return 6;
  if (role === 'client') return 7;
  if (role === 'sales') return 8;
  if (role === 'marketing') return 9;
  return 3;
};

interface Attendance {
  id: string;
  user_id: string;
  name: string;   // 👈 add this
  date: string;
  check_in: string;
  check_out: string;
  working_status: string;
  status: string;
}

interface Employee {
  id: string;
  email: string;
  name: string;
  role_id: number; // 1=admin, 2=hr, 3=employee
  department: string;
  //join_date: string;
  is_active: boolean;
  approval_status: 'pending' | 'approved' | 'rejected';
  created_at: string;
}


interface JobOpening {
  id: string;
  title: string;
  department: string;
  location: string;
  type: string;
  experience: string;
  salary: string;
  skills: string[];
  description: string;
  requirements: string[];
  responsibilities: string[];
  benefits: string[];
  is_active: boolean;
  approval_status: 'pending' | 'approved' | 'rejected';
  approved_by?: string;
  posted_date: string;
  application_deadline: string;
  created_by: string;
  created_by_name?: string;
}

interface ContactInquiry {
  id: string;
  name: string;
  email: string;
  company: string;
  subject: string;
  message: string;
  status: 'new' | 'in_progress' | 'resolved' | 'closed';
  created_at: string;
}

const AdminDashboard = () => {
  const { user } = useAuth();
  const [attendance, setAttendance] = useState<Attendance[]>([]);
  const [attendancePage, setAttendancePage] = useState(1);
  const [attendanceSearch, setAttendanceSearch] = useState('');
  const [applications, setApplications] = useState<any[]>([]);
  const [selectedApplication, setSelectedApplication] = useState<any | null>(null);
  const [showApplicationModal, setShowApplicationModal] = useState(false);
  const [selectedInquiry, setSelectedInquiry] = useState<any | null>(null);
  const [showInquiryModal, setShowInquiryModal] = useState(false);
  const [activeTab, setActiveTab] = useState(
    user?.role === 'finance' || Number(user?.role_id) === 5 ? 'billing' : 'employees'
  );
  const [employees, setEmployees] = useState<Employee[]>([]);
  const [pendingUsers, setPendingUsers] = useState<Employee[]>([]);
  const [jobs, setJobs] = useState<JobOpening[]>([]);
  const [inquiries, setInquiries] = useState<ContactInquiry[]>([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [showEmployeeForm, setShowEmployeeForm] = useState(false);
  const [showJobForm, setShowJobForm] = useState(false);
  const [editingEmployee, setEditingEmployee] = useState<Employee | null>(null);
  const [editingJob, setEditingJob] = useState<JobOpening | null>(null);

  const [adminPreviewMode, setAdminPreviewMode] = useState<'master' | 'hr' | 'sales' | 'marketing' | 'client' | 'finance' | 'employee'>('master');

  const [employeeForm, setEmployeeForm] = useState({
    name: '',
    email: '',
    password: '',
    role: 'employee' as 'admin' | 'employee' | 'hr' | 'product_manager' | 'scrum_master' | 'client' | 'finance' | 'sales' | 'marketing',
    department: '',
    joinDate: new Date().toISOString().split('T')[0],
    isActive: true
  });

  const [jobForm, setJobForm] = useState({
    title: '',
    department: '',
    location: 'Bangalore, India',
    type: 'Full-time',
    experience: '',
    salary: '',
    skills: '',
    description: '',
    requirements: '',
    responsibilities: '',
    benefits: '',
    applicationDeadline: '',
    isActive: true
  });

  const [selectedUserAttendance, setSelectedUserAttendance] = useState<any[]>([]);
  const [showAttendanceModal, setShowAttendanceModal] = useState(false);
  const [selectedUserName, setSelectedUserName] = useState('');
  const [attendanceLoading, setAttendanceLoading] = useState(false);

  const viewUserAttendance = async (userId: string, name: string) => {
    setAttendanceLoading(true);
    setSelectedUserName(name);
    setShowAttendanceModal(true);
    try {
      const res = await dbHelpers.getUserAttendance(userId);
      if (res?.status) {
        setSelectedUserAttendance(res.data);
      } else {
        setSelectedUserAttendance([]);
      }
    } catch (err) {
      console.error(err);
      setSelectedUserAttendance([]);
    } finally {
      setAttendanceLoading(false);
    }
  };


  useEffect(() => {
    loadData();
  }, []);







  const loadData = async () => {
    setLoading(true);

    try {
      // ================= USERS =================
      const usersRes = await dbHelpers.getAllUsers();
      console.log("USERS API RESPONSE:", usersRes);

      const users = Array.isArray(usersRes?.data) ? usersRes.data : [];

      const normalizedUsers = users.map((u: any) => ({
        ...u,
        is_active: Number(u.is_active) === 1,
      }));

      setEmployees(normalizedUsers);
      setPendingUsers(
        normalizedUsers.filter((u: any) => u.approval_status === "pending")
      );

      // ================= JOBS =================
      try {
        const jobsRes = await dbHelpers.getJobs();
        console.log("JOBS API RESPONSE:", jobsRes);

        const jobsData = Array.isArray(jobsRes?.data)
          ? jobsRes.data
          : Array.isArray(jobsRes)
            ? jobsRes
            : [];

        const normalizedJobs = jobsData.map((j: any) => {
          let parsedSkills: string[] = [];
          if (typeof j.skills === 'string') {
            parsedSkills = j.skills.split(',').map((s: string) => s.trim()).filter(Boolean);
          } else if (Array.isArray(j.skills)) {
            parsedSkills = j.skills;
          }

          // Map type
          let jobType = j.job_type || j.type || 'Full-time';
          if (jobType === 'full_time') jobType = 'Full-time';
          else if (jobType === 'part_time') jobType = 'Part-time';
          else if (jobType === 'contract') jobType = 'Contract';
          else if (jobType === 'internship') jobType = 'Internship';
          else if (jobType === 'temporary') jobType = 'Temporary';

          // Map salary
          let salaryStr = 'Competitive';
          if (j.salary_from && j.salary_to) {
            salaryStr = `₹${Number(j.salary_from).toLocaleString()} - ₹${Number(j.salary_to).toLocaleString()} / year`;
          } else if (j.salary_range) {
            salaryStr = j.salary_range;
          } else if (j.salary) {
            salaryStr = j.salary;
          }

          // Map arrays or json-strings safely
          const parseJsonArray = (val: any) => {
            if (Array.isArray(val)) return val;
            if (typeof val === 'string') {
              try {
                const parsed = JSON.parse(val);
                if (Array.isArray(parsed)) return parsed;
              } catch (e) {
                return [val];
              }
            }
            return [];
          };

          return {
            ...j,
            id: String(j.id),
            title: j.title || j.job_title || '',
            department: j.department || '',
            location: j.location || '',
            type: jobType,
            experience: j.experience_required || j.experience || 'Not specified',
            salary: salaryStr,
            skills: parsedSkills,
            description: j.description || '',
            requirements: parseJsonArray(j.requirements),
            responsibilities: parseJsonArray(j.responsibilities),
            benefits: parseJsonArray(j.benefits),
            is_active: Number(j.is_active) === 1,
            posted_date: j.created_at || j.posted_date || new Date().toISOString(),
            application_deadline: j.application_deadline || '',
            approval_status: j.approve_status || 'pending',
            created_by_name: j.creator_name || 'Unknown'
          };
        });

        setJobs(normalizedJobs);
      } catch (jobError) {
        console.error("Jobs load error:", jobError);
        setJobs([]);
      }


      // ================= ATTENDANCE =================
      try {
        const attendanceRes = await dbHelpers.getAllAttendance();
        console.log("ATTENDANCE API RESPONSE:", attendanceRes);

        const attendanceData = attendanceRes?.data || [];

        setAttendance(attendanceData);
      } catch (attendanceError) {
        console.error("Attendance load error:", attendanceError);
        setAttendance([]);
      }



      // ================= INQUIRIES =================
      try {
        const inquiriesRes = await dbHelpers.getAllInquiries();
        console.log("INQUIRIES API RESPONSE:", inquiriesRes);

        const raw = Array.isArray(inquiriesRes?.data)
          ? inquiriesRes.data
          : [];

        const normalizedInquiries = raw.map((i: any) => ({
          id: i.id,
          name: i.name,
          email: i.email,
          company: i.company_name || i.company || '',
          phone: i.phone || '',
          subject: i.subject,
          message: i.message,
          status: i.status || "new",
          created_at: i.created_at,
        }));

        setInquiries(normalizedInquiries);
      } catch (inquiriesError) {
        console.error("Inquiries load error:", inquiriesError);
        setInquiries([]);
      }

      // ================= APPLICATIONS =================
      try {
        const appsRes = await dbHelpers.getApplications();
        console.log("APPLICATIONS API RESPONSE:", appsRes);
        const appsData = Array.isArray(appsRes?.data) ? appsRes.data : [];
        setApplications(appsData);
      } catch (appsError) {
        console.error("Applications load error:", appsError);
        setApplications([]);
      }

    } catch (error) {
      console.error("Load data error:", error);
      alert("Error loading dashboard data.");
    } finally {
      setLoading(false);
    }
  };



  // Load attendance

  const handleCreateEmployee = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      const payload = {
        name: employeeForm.name,
        email: employeeForm.email,
        password: employeeForm.password,
        role_id: roleLabelToId(employeeForm.role),
        department: employeeForm.department,
        //join_date: employeeForm.joinDate,
        is_active: employeeForm.isActive ? 1 : 0,
      };

      console.log('CREATE PAYLOAD:', payload);
      const token = localStorage.getItem('x2infotech_token');
      const res = await dbHelpers.createUser(payload, token);

      if (res?.status !== true && res?.status !== 'true') {
        alert(res?.message || 'Error creating employee');
        return;
      }

      await loadData();
      setShowEmployeeForm(false);
      resetEmployeeForm();
      alert('Employee created successfully ✅');
    } catch (error) {
      console.error(error);
      alert('Error creating employee');
    }
  };



  const handleApproveUser = async (id: string) => {
    try {
      const token = localStorage.getItem('x2infotech_token');
      const res = await dbHelpers.approveUser(id, token);

      if (!res?.status) {
        alert(res?.message || 'Error approving user');
        return;
      }

      alert('User approved successfully ✅');
      await loadData();
    } catch (error) {
      alert('Error: ' + (error instanceof Error ? error.message : 'Unknown error'));
    }
  };

  const handleRejectUser = async (id: string) => {
    if (!confirm('Are you sure you want to reject this user?')) return;

    try {
      const token = localStorage.getItem('x2infotech_token');
      const res = await dbHelpers.rejectUser(id, token);

      if (!res?.status) {
        alert(res?.message || 'Error rejecting user');
        return;
      }

      alert('User rejected successfully ❌');
      await loadData();
    } catch (error) {
      alert('Error: ' + (error instanceof Error ? error.message : 'Unknown error'));
    }
  };


  const handleDeleteEmployee = async (id: string) => {
    if (!confirm('Are you sure you want to delete this employee?')) return;

    try {
      await dbHelpers.deleteUser(id, localStorage.getItem('x2infotech_token'));
      await loadData();
    } catch (error) {
      console.error('Error deleting employee:', error);
      alert('Error deleting employee. Please try again.');
    }
  };



  const handleCreateJob = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      const payload = {
        title: jobForm.title,
        department: jobForm.department,
        location: jobForm.location,
        type: jobForm.type,
        experience: jobForm.experience,
        salary: jobForm.salary,
        skills: jobForm.skills,
        description: jobForm.description,
        requirements: jobForm.requirements,
        responsibilities: jobForm.responsibilities,
        benefits: jobForm.benefits,
        is_active: jobForm.isActive ? 1 : 0,
        application_deadline: jobForm.applicationDeadline,
        created_by: user?.id,
      };

      console.log('JOB PAYLOAD:', payload);

      const res = await dbHelpers.createJob(payload);

      if (!res?.status) {
        alert(res?.message || 'Job creation failed');
        return;
      }

      alert('Job created successfully ✅');
      setShowJobForm(false);
      resetJobForm();
      loadData();
    } catch (err) {
      console.error(err);
      alert('Error creating job. Please try again.');
    }
  };



  const handleUpdateEmployee = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!editingEmployee) return;

    try {
      const payload = {
        id: editingEmployee.id,
        name: employeeForm.name,
        role_id: roleLabelToId(employeeForm.role),
        department: employeeForm.department,
        is_active: employeeForm.isActive ? 1 : 0,
      };

      console.log('UPDATE PAYLOAD:', payload);
      const res = await dbHelpers.updateUser(payload);
      //const res = await dbHelpers.updateUser(payload, localStorage.getItem('x2infotech_token'));

      if (!res?.status) {
        alert(res?.message || 'Error updating employee');
        return;
      }

      await loadData();
      setEditingEmployee(null);
      setShowEmployeeForm(false);
      resetEmployeeForm();
      alert('Employee updated successfully ✅');
    } catch (error) {
      console.error(error);
      alert('Error updating employee');
    }
  };


  const handleUpdateJob = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!editingJob) return;

    try {
      const updatedJob = {
        title: jobForm.title,
        department: jobForm.department,
        location: jobForm.location,
        type: jobForm.type,
        experience: jobForm.experience,
        salary: jobForm.salary,
        skills: jobForm.skills.split(',').map(s => s.trim()).filter(s => s),
        description: jobForm.description,
        requirements: jobForm.requirements.split('\n').filter(r => r.trim()),
        responsibilities: jobForm.responsibilities.split('\n').filter(r => r.trim()),
        benefits: jobForm.benefits.split('\n').filter(b => b.trim()),
        is_active: jobForm.isActive ? 1 : 0,
        application_deadline: jobForm.applicationDeadline
      };

      await dbHelpers.updateJob({ id: editingJob.id, ...updatedJob }, localStorage.getItem('x2infotech_token'));
      await loadData();
      setEditingJob(null);
      setShowJobForm(false);
      resetJobForm();
    } catch (error) {
      console.error('Error updating job:', error);
      alert('Error updating job. Please try again.');
    }
  };

  const handleApproveJob = async (id: string) => {
    if (!user) return;

    try {
      await dbHelpers.approveJob(id, localStorage.getItem('x2infotech_token'));
      await loadData();
    } catch (error) {
      console.error('Error approving job:', error);
      alert('Error approving job. Please try again.');
    }
  };

  const handleRejectJob = async (id: string) => {
    if (!user) return;

    if (!confirm('Are you sure you want to reject this job posting?')) return;

    try {
      await dbHelpers.rejectJob(id, localStorage.getItem('x2infotech_token'));
      await loadData();
    } catch (error) {
      console.error('Error rejecting job:', error);
      alert('Error rejecting job. Please try again.');
    }
  };

  const handleDeleteJob = async (id: string) => {
    if (!confirm('Are you sure you want to disable this job posting?')) return;

    try {
      await dbHelpers.updateJob({ id, is_active: 0 });
      await loadData();
    } catch (error) {
      console.error('Error disabling job:', error);
      alert('Error disabling job. Please try again.');
    }
  };

  const resetEmployeeForm = () => {
    setEmployeeForm({
      name: '',
      email: '',
      password: '',
      role: 'employee',
      department: '',
      joinDate: new Date().toISOString().split('T')[0],
      isActive: true
    });
  };

  const resetJobForm = () => {
    setJobForm({
      title: '',
      department: '',
      location: 'Bangalore, India',
      type: 'Full-time',
      experience: '',
      salary: '',
      skills: '',
      description: '',
      requirements: '',
      responsibilities: '',
      benefits: '',
      applicationDeadline: '',
      isActive: true
    });
  };


  const startEditEmployee = (employee: Employee) => {
    setEditingEmployee(employee);
    setEmployeeForm({
      name: employee.name,
      email: employee.email,
      password: '',
      role: roleIdToLabel(employee.role_id), // ✅ FIX
      department: employee.department,
      //joinDate: employee.join_date,
      joinDate: employee.created_at.split('T')[0],
      isActive: employee.is_active
    });
    setShowEmployeeForm(true);
  };

  const startEditJob = (job: any) => {
    setEditingJob(job);
    
    // Safely parse skills array
    let skillsStr = '';
    if (typeof job.skills === 'string') {
      skillsStr = job.skills;
    } else if (Array.isArray(job.skills)) {
      skillsStr = job.skills.join(', ');
    }

    // Safely parse arrays
    const arrayToNewlineString = (val: any) => {
      if (Array.isArray(val)) return val.join('\n');
      if (typeof val === 'string') {
        try {
          const parsed = JSON.parse(val);
          if (Array.isArray(parsed)) return parsed.join('\n');
        } catch (e) {
          return val;
        }
      }
      return '';
    };

    setJobForm({
      title: job.title || '',
      department: job.department || '',
      location: job.location || '',
      type: job.type || job.job_type || 'Full-time',
      experience: job.experience || job.experience_required || '',
      salary: job.salary || '',
      skills: skillsStr,
      description: job.description || '',
      requirements: arrayToNewlineString(job.requirements),
      responsibilities: arrayToNewlineString(job.responsibilities),
      benefits: arrayToNewlineString(job.benefits),
      applicationDeadline: job.application_deadline || '',
      isActive: Number(job.is_active) === 1
    });
    setShowJobForm(true);
  };

  /*const filteredEmployees = employees.filter(emp =>
    emp.approval_status === 'approved' && (
      emp.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      emp.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
      emp.department.toLowerCase().includes(searchTerm.toLowerCase())
    )
  );*/

  const filteredEmployees = employees.filter(emp =>
    emp.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    emp.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
    emp.department.toLowerCase().includes(searchTerm.toLowerCase())
  );



  const filteredJobs = jobs.filter(job =>
    job.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
    job.department.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const filteredInquiries = inquiries.filter(inquiry =>
    inquiry.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    inquiry.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
    inquiry.subject.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const filteredAttendance = attendance.filter((att: any) => {
    const searchLower = attendanceSearch.toLowerCase().trim();
    if (!searchLower) return true;
    return (
      (att.name || '').toLowerCase().includes(searchLower) ||
      (att.department || '').toLowerCase().includes(searchLower) ||
      (att.date || '').toLowerCase().includes(searchLower)
    );
  });

  const attendanceItemsPerPage = 10;
  const totalAttendancePages = Math.ceil(filteredAttendance.length / attendanceItemsPerPage) || 1;
  const startIndex = (attendancePage - 1) * attendanceItemsPerPage;
  const paginatedAttendance = filteredAttendance.slice(startIndex, startIndex + attendanceItemsPerPage);
  /*
    if (!user || (user.role !== 'admin' && user.role !== 'hr')) {
      return (
        <div className="text-center py-12">
          <AlertCircle className="h-16 w-16 text-red-400 mx-auto mb-4" />
          <h3 className="text-lg font-medium text-gray-900 mb-2">Access Denied</h3>
          <p className="text-gray-600">You don't have permission to access this page.</p>
        </div>
      );
    }*/

  if (!user) {
    return (
      <div className="text-center py-12">
        <AlertCircle className="h-16 w-16 text-red-400 mx-auto mb-4" />
        <h3 className="text-lg font-medium text-gray-900 mb-2">Please Log In</h3>
        <p className="text-gray-600">You must be logged in to view your dashboard.</p>
      </div>
    );
  }

  // Dedicated role redirection so each role gets its tailored dashboard
  if (user.role === 'hr' || Number(user.role_id) === 2) {
    return <HRDashboardView />;
  }
  if (user.role === 'sales' || Number(user.role_id) === 8 || (user.department || '').toLowerCase() === 'sales') {
    return <SalesDashboard />;
  }
  if (user.role === 'marketing' || Number(user.role_id) === 9 || (user.department || '').toLowerCase() === 'marketing') {
    return <MarketingDashboard />;
  }
  if (user.role === 'client' || Number(user.role_id) === 7) {
    return <ClientDashboard />;
  }
  if (user.role === 'employee' || Number(user.role_id) === 3) {
    return <EmployeeDashboard />;
  }

  // Admin Live Preview Mode
  if (adminPreviewMode !== 'master') {
    return (
      <div className="flex-1 bg-slate-50 min-h-screen">
        <div className="bg-emerald-800 text-white px-6 py-3 flex flex-col sm:flex-row items-center justify-between gap-3 shadow-md sticky top-16 z-30">
          <div className="flex items-center gap-2 text-sm font-semibold">
            <ShieldCheck className="w-5 h-5 text-emerald-300" />
            <span>Live Admin Preview: Currently viewing system as <strong>{adminPreviewMode.toUpperCase()}</strong></span>
          </div>
          <button
            onClick={() => setAdminPreviewMode('master')}
            className="bg-white text-emerald-800 px-4 py-1.5 rounded-xl font-bold hover:bg-emerald-50 text-xs shadow-sm cursor-pointer transition-colors"
          >
            ← Return to Comprehensive Admin Dashboard
          </button>
        </div>
        {adminPreviewMode === 'hr' && <HRDashboardView />}
        {adminPreviewMode === 'sales' && <SalesDashboard />}
        {adminPreviewMode === 'marketing' && <MarketingDashboard />}
        {adminPreviewMode === 'client' && <ClientDashboard />}
        {adminPreviewMode === 'employee' && <EmployeeDashboard />}
        {adminPreviewMode === 'finance' && <div className="py-8"><BillingManager currentUser={user} /></div>}
      </div>
    );
  }

  return (
    <div className="flex-1 bg-gray-50 py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Admin Role View Switcher */}
        <div className="bg-white rounded-2xl p-4 shadow-sm border border-slate-200 mb-6 flex flex-wrap items-center justify-between gap-3">
          <div className="flex items-center gap-2">
            <ShieldCheck className="w-5 h-5 text-emerald-600" />
            <span className="text-xs font-bold uppercase tracking-wider text-slate-800">Department View Switcher:</span>
            <span className="text-xs text-slate-500 hidden sm:inline">Preview tailored dashboards</span>
          </div>
          <div className="flex flex-wrap items-center gap-1.5 text-xs">
            <button
              onClick={() => setAdminPreviewMode('master')}
              className={`px-3 py-1.5 rounded-lg font-bold transition-all cursor-pointer ${
                adminPreviewMode === 'master' ? 'bg-emerald-600 text-white shadow-xs' : 'bg-slate-100 text-slate-700 hover:bg-slate-200'
              }`}
            >
              👑 Comprehensive (Full)
            </button>
            <button
              onClick={() => setAdminPreviewMode('hr')}
              className="px-3 py-1.5 rounded-lg font-bold bg-slate-100 text-slate-700 hover:bg-slate-200 transition-all cursor-pointer"
            >
              👥 HR View
            </button>
            <button
              onClick={() => setAdminPreviewMode('sales')}
              className="px-3 py-1.5 rounded-lg font-bold bg-slate-100 text-slate-700 hover:bg-slate-200 transition-all cursor-pointer"
            >
              💼 Sales View
            </button>
            <button
              onClick={() => setAdminPreviewMode('marketing')}
              className="px-3 py-1.5 rounded-lg font-bold bg-slate-100 text-slate-700 hover:bg-slate-200 transition-all cursor-pointer"
            >
              📈 Marketing View
            </button>
            <button
              onClick={() => setAdminPreviewMode('client')}
              className="px-3 py-1.5 rounded-lg font-bold bg-slate-100 text-slate-700 hover:bg-slate-200 transition-all cursor-pointer"
            >
              🤝 Client View
            </button>
            <button
              onClick={() => setAdminPreviewMode('employee')}
              className="px-3 py-1.5 rounded-lg font-bold bg-slate-100 text-slate-700 hover:bg-slate-200 transition-all cursor-pointer"
            >
              💻 Employee View
            </button>
          </div>
        </div>

        {/* Header */}
        <div className="mb-8">
          <h1 className="text-2xl sm:text-3xl font-bold text-slate-900">
            {Number(user.role_id) === 1 || user.role === 'admin'
              ? 'Comprehensive Admin Dashboard'
              : Number(user.role_id) === 5 || user.role === 'finance'
              ? 'Finance & Billing Dashboard'
              : 'Enterprise Operations Dashboard'}
          </h1>
          <p className="text-slate-600 mt-2 text-sm">
            Master executive control center across employees, recruitment, attendance, CRM pipeline, marketing, and billing.
          </p>
        </div>

        {/* Stats Cards */}
        <div className="grid grid-cols-1 md:grid-cols-5 gap-6 mb-8">
          <div className="bg-white rounded-lg shadow-md p-6 border-l-4 border-blue-500">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-600">Total Employees</p>
                <p className="text-2xl font-bold text-blue-600">{employees.filter(emp => emp.approval_status === 'approved').length}</p>
              </div>
              <Users className="h-8 w-8 text-blue-500" />
            </div>
          </div>
          <div className="bg-white rounded-lg shadow-md p-6 border-l-4 border-orange-500">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-600">Pending Approvals</p>
                <p className="text-2xl font-bold text-orange-600">{pendingUsers.length}</p>
              </div>
              <UserCheck className="h-8 w-8 text-orange-500" />
            </div>
          </div>
          <div className="bg-white rounded-lg shadow-md p-6 border-l-4 border-green-500">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-600">Active Jobs</p>
                <p className="text-2xl font-bold text-green-600">{jobs.filter(j => j.is_active && j.approval_status === 'approved').length}</p>
              </div>
              <Briefcase className="h-8 w-8 text-green-500" />
            </div>
          </div>
          <div className="bg-white rounded-lg shadow-md p-6 border-l-4 border-yellow-500">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-600">New Inquiries</p>
                <p className="text-2xl font-bold text-yellow-600">{inquiries.filter(i => i.status === 'new').length}</p>
              </div>
              <Mail className="h-8 w-8 text-yellow-500" />
            </div>
          </div>
          <div className="bg-white rounded-lg shadow-md p-6 border-l-4 border-purple-500">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-600">Pending Jobs</p>
                <p className="text-2xl font-bold text-purple-600">{jobs.filter(j => j.approval_status === 'pending').length}</p>
              </div>
              <FileText className="h-8 w-8 text-purple-500" />
            </div>
          </div>
        </div>

        {/* Tabs */}
        <div className="bg-white rounded-lg shadow-md mb-6">
          <div className="border-b border-gray-200">
            <nav className="flex space-x-8 px-6">
              {[
                { id: 'employees', label: 'Employees', icon: Users },
                { id: 'pending', label: 'Pending Approvals', icon: UserCheck, count: pendingUsers.length },
                { id: 'jobs', label: 'Job Postings', icon: Briefcase },
                { id: 'applications', label: 'Applications', icon: FileText, count: applications.filter(a => a.status === 'new').length },
                { id: 'attendance', label: 'Attendance', icon: Calendar },
                { id: 'inquiries', label: 'Inquiries', icon: Mail },
                { id: 'crm', label: 'Sales CRM', icon: BarChart3 },
                { id: 'marketing', label: 'Marketing', icon: Megaphone },
                { id: 'billing', label: 'Billing & Invoices', icon: Receipt }
              ].map((tab) => {
                const Icon = tab.icon;
                return (
                  <button
                    key={tab.id}
                    onClick={() => setActiveTab(tab.id)}
                    className={`flex items-center py-4 px-1 border-b-2 font-medium text-sm ${activeTab === tab.id
                      ? 'border-brand-primary text-brand-primary'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                      }`}
                  >
                    <Icon className="h-5 w-5 mr-2" />
                    {tab.label}
                    {tab.count && tab.count > 0 && (
                      <span className="ml-2 bg-red-500 text-white text-xs rounded-full px-2 py-1">
                        {tab.count}
                      </span>
                    )}
                  </button>
                );
              })}
            </nav>
          </div>

          {/* Search and Actions */}
          {activeTab !== 'billing' && (
            <div className="p-6 border-b border-gray-200">
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-4">
                  {activeTab !== 'attendance' && (
                    <div className="relative">
                      <Search className="absolute left-3 top-3 h-4 w-4 text-gray-400" />
                      <input
                        type="text"
                        placeholder="Search..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-primary focus:border-transparent"
                      />
                    </div>
                  )}
                </div>
                <div className="flex space-x-3">
                  {activeTab === 'employees' && (
                    <button
                      onClick={() => setShowEmployeeForm(true)}
                      className="bg-brand-primary text-white px-4 py-2 rounded-lg font-medium hover:bg-brand-dark transition-colors duration-200 flex items-center"
                    >
                      <UserPlus className="h-4 w-4 mr-2" />
                      Add Employee
                    </button>
                  )}
                  {activeTab === 'jobs' && (
                    <button
                      onClick={() => setShowJobForm(true)}
                      className="bg-brand-primary text-white px-4 py-2 rounded-lg font-medium hover:bg-brand-dark transition-colors duration-200 flex items-center"
                    >
                      <Plus className="h-4 w-4 mr-2" />
                      Add Job
                    </button>
                  )}
                </div>
              </div>
            </div>
          )}

          {/* Content */}
          <div className="p-6">
            {loading ? (
              <div className="text-center py-12">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-brand-primary mx-auto"></div>
                <p className="text-gray-600 mt-4">Loading...</p>
              </div>
            ) : (
              <>
                {/* Employees Tab */}
                {activeTab === 'employees' && (
                  <div className="overflow-x-auto">
                    <table className="w-full text-sm">
                      <thead>
                        <tr className="border-b border-gray-200">
                          <th className="text-left py-3 px-4 font-medium text-gray-900">Name</th>
                          <th className="text-left py-3 px-4 font-medium text-gray-900">Email</th>
                          <th className="text-left py-3 px-4 font-medium text-gray-900">Role</th>
                          <th className="text-left py-3 px-4 font-medium text-gray-900">Department</th>
                          <th className="text-left py-3 px-4 font-medium text-gray-900">Join Date</th>
                          <th className="text-left py-3 px-4 font-medium text-gray-900">Status</th>
                          <th className="text-left py-3 px-4 font-medium text-gray-900">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredEmployees.map((employee) => (
                          <tr key={employee.id} className="border-b border-gray-100 hover:bg-gray-50">
                            <td className="py-3 px-4 font-medium text-gray-900">{employee.name}</td>
                            <td className="py-3 px-4 text-gray-600">{employee.email}</td>
                            <td className="py-3 px-4">
                              <span className="px-2 py-1 rounded-full text-xs font-medium bg-gray-100">
                                {roleIdToLabel(employee.role_id).toUpperCase()}
                              </span>

                            </td>
                            <td className="py-3 px-4 text-gray-600">{employee.department}</td>
                            <td className="py-3 px-4 text-gray-600">{new Date(employee.created_at).toLocaleDateString()}</td>
                            <td className="py-3 px-4">
                              <span className={`px-2 py-1 rounded-full text-xs font-medium ${employee.approval_status === 'approved'
                                ? 'bg-green-100 text-green-800'
                                : 'bg-yellow-100 text-yellow-800'
                                }`}>
                                {employee.approval_status.toUpperCase()}
                              </span>

                            </td>
                            <td className="py-3 px-4">
                              <div className="flex space-x-2">
                                <button
                                  onClick={() => startEditEmployee(employee)}
                                  className="text-brand-primary hover:bg-brand-light p-1 rounded"
                                >
                                  <Edit className="h-4 w-4" />
                                </button>
                                <button
                                  onClick={() => handleDeleteEmployee(employee.id)}
                                  className="text-red-600 hover:bg-red-50 p-1 rounded"
                                >
                                  <Trash2 className="h-4 w-4" />
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}

                {/* Pending Approvals Tab */}
                {activeTab === 'pending' && (
                  <div className="space-y-4">
                    {pendingUsers.map((user) => (
                      <div key={user.id} className="bg-gray-50 rounded-lg p-6 border border-gray-200">
                        <div className="flex items-start justify-between">
                          <div className="flex-1">
                            <div className="flex items-center space-x-4 mb-2">
                              <h3 className="text-lg font-semibold text-brand-secondary">{user.name}</h3>
                              <span className="bg-orange-100 text-orange-800 px-2 py-1 rounded-full text-xs font-medium">
                                Pending Approval
                              </span>
                            </div>
                            <div className="grid grid-cols-2 gap-4 text-sm text-gray-600 mb-4">
                              <div><span className="font-medium">Email:</span> {user.email}</div>
                              <div>
                                <span className="font-medium">Role:</span>{' '}
                                {roleIdToLabel(user.role_id).toUpperCase()}
                              </div>

                              <div><span className="font-medium">Department:</span> {user.department}</div>
                              <div><span className="font-medium">Join Date:</span> {new Date(user.created_at).toLocaleDateString()}</div>
                            </div>
                          </div>
                          <span className="text-xs text-gray-500">
                            Applied: {new Date(user.created_at).toLocaleDateString()}
                          </span>
                        </div>
                        <div className="flex space-x-3">
                          <button
                            onClick={() => handleApproveUser(user.id)}
                            className="bg-green-600 text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-green-700 transition-colors duration-200 flex items-center"
                          >
                            <UserCheck className="h-4 w-4 mr-2" />
                            Approve
                          </button>
                          <button
                            onClick={() => handleRejectUser(user.id)}
                            className="bg-red-600 text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-red-700 transition-colors duration-200 flex items-center"
                          >
                            <UserX className="h-4 w-4 mr-2" />
                            Reject
                          </button>
                        </div>
                      </div>
                    ))}
                    {pendingUsers.length === 0 && (
                      <div className="text-center py-8 text-gray-500">
                        No pending user approvals
                      </div>
                    )}
                  </div>
                )}

                {/* Jobs Tab */}
                {activeTab === 'jobs' && (
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {filteredJobs.map((job) => (
                      <div key={job.id} className="bg-gray-50 rounded-lg p-6 border border-gray-200">
                        <div className="flex items-start justify-between mb-4">
                          <div className="flex-1">
                            <h3 className="text-lg font-semibold text-brand-secondary mb-2">{job.title}</h3>
                            <div className="space-y-1 text-sm text-gray-600">
                              <div className="flex items-center">
                                <Building className="h-4 w-4 mr-1 text-brand-primary" />
                                <span>{job.department}</span>
                              </div>
                              <div className="flex items-center">
                                <MapPin className="h-4 w-4 mr-1 text-brand-primary" />
                                <span>{job.location}</span>
                              </div>
                              <div className="flex items-center">
                                <DollarSign className="h-4 w-4 mr-1 text-brand-primary" />
                                <span>{job.salary}</span>
                              </div>
                              <div className="flex items-center">
                                <Calendar className="h-4 w-4 mr-1 text-brand-primary" />
                                <span>Deadline: {new Date(job.application_deadline).toLocaleDateString()}</span>
                              </div>
                            </div>
                          </div>
                          <div className="flex flex-col space-y-0.1">
                            <span className={`px-2 py-1 rounded-full text-xs font-medium ${job.is_active ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
                              }`}>
                              {job.is_active ? 'Active' : 'Inactive'}
                            </span>
                            <span className={`px-2 py-1 rounded-full text-xs font-medium ${job.approval_status === 'approved' ? 'bg-green-100 text-green-800' :
                              job.approval_status === 'pending' ? 'bg-yellow-100 text-yellow-800' :
                                'bg-red-100 text-red-800'
                              }`}>
                              {job.approval_status}
                            </span>
                          </div>
                        </div>

                        <p className="text-gray-600 text-sm mb-4 line-clamp-3">{job.description}</p>

                        <div className="flex items-center justify-between">
                          <div className="flex space-x-2">
                            <button
                              onClick={() => startEditJob(job)}
                              className="text-brand-primary hover:bg-brand-light p-2 rounded-lg transition-colors duration-200"
                            >
                              <Edit className="h-4 w-4" />
                            </button>
                            <button
                              onClick={() => handleDeleteJob(job.id)}
                              className="text-red-600 hover:bg-red-50 p-2 rounded-lg transition-colors duration-200"
                            >
                              <Trash2 className="h-4 w-4" />
                            </button>
                            {job.approval_status === 'pending' && (
                              <>
                                <button
                                  onClick={() => handleApproveJob(job.id)}
                                  className="text-green-600 hover:bg-green-50 p-2 rounded-lg transition-colors duration-200"
                                >
                                  <CheckCircle className="h-4 w-4" />
                                </button>
                                <button
                                  onClick={() => handleRejectJob(job.id)}
                                  className="text-red-600 hover:bg-red-50 p-2 rounded-lg transition-colors duration-200"
                                >
                                  <XCircle className="h-4 w-4" />
                                </button>
                              </>
                            )}
                          </div>
                          <span className="text-xs text-gray-500">
                            By: {job.created_by_name || 'Unknown'}
                          </span>
                        </div>
                      </div>
                    ))}
                  </div>
                )}


                {activeTab === 'attendance' && (
                  <div className="space-y-4">
                    {/* Attendance Filter Search Bar */}
                    <div className="flex justify-between items-center mb-2">
                      <div className="relative w-72">
                        <input
                          type="text"
                          placeholder="Filter attendance..."
                          value={attendanceSearch}
                          onChange={(e) => {
                            setAttendanceSearch(e.target.value);
                            setAttendancePage(1); // Reset page on filter change
                          }}
                          className="w-full pl-9 pr-4 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-brand-primary focus:border-transparent transition-all duration-200"
                        />
                        <Search className="absolute left-3 top-2.5 h-4 w-4 text-gray-400" />
                      </div>
                      <div className="text-xs text-gray-500 font-medium">
                        Total Records: {filteredAttendance.length}
                      </div>
                    </div>

                    <div className="overflow-x-auto">
                      <table className="w-full text-sm">
                        <thead>
                          <tr className="border-b border-gray-200">
                            <th className="py-3 px-4 text-left">Employee</th>
                            <th className="py-3 px-4 text-left">Date</th>
                            <th className="py-3 px-4 text-left">Check In</th>
                            <th className="py-3 px-4 text-left">Check Out</th>
                            <th className="py-3 px-4 text-left">Status</th>
                            <th className="py-3 px-4 text-left">Working</th>
                          </tr>
                        </thead>
                        <tbody>
                          {paginatedAttendance.length === 0 ? (
                            <tr>
                              <td colSpan={6} className="py-6 text-center text-gray-400">
                                No attendance records found
                              </td>
                            </tr>
                          ) : (
                            paginatedAttendance.map((att) => {
                              return (
                                <tr
                                  key={att.id}
                                  className="border-b hover:bg-gray-50 cursor-pointer"
                                  onClick={() => viewUserAttendance(att.user_id, att.name)}
                                  title="Click to view full history"
                                >
                                  <td className="py-3 px-4 font-medium text-brand-secondary">{att.name}</td>

                                  <td className="py-3 px-4">
                                    {new Date(att.date).toLocaleDateString()}
                                  </td>

                                  <td className="py-3 px-4">
                                    {att.check_in || "-"}
                                  </td>

                                  <td className="py-3 px-4">
                                    {att.check_out || "-"}
                                  </td>

                                  <td className="py-3 px-4">
                                    <span
                                      className={`px-2 py-1 rounded-full text-xs ${att.status === "late"
                                        ? "bg-red-100 text-red-700"
                                        : "bg-green-100 text-green-700"
                                        }`}
                                    >
                                      {att.status}
                                    </span>
                                  </td>

                                  <td className="py-3 px-4">
                                    {att.working_status}
                                  </td>
                                </tr>
                              );
                            })
                          )}
                        </tbody>
                      </table>
                    </div>

                    {/* Pagination Controls */}
                    {totalAttendancePages > 1 && (
                      <div className="flex items-center justify-between border-t border-gray-200 pt-4 mt-2">
                        <div className="text-xs text-gray-500">
                          Showing {Math.min(startIndex + 1, filteredAttendance.length)} to {Math.min(startIndex + attendanceItemsPerPage, filteredAttendance.length)} of {filteredAttendance.length} records
                        </div>
                        <div className="flex space-x-2">
                          <button
                            onClick={() => setAttendancePage(p => Math.max(p - 1, 1))}
                            disabled={attendancePage === 1}
                            className="px-3.5 py-1.5 border border-gray-300 rounded-lg text-xs font-semibold text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200"
                          >
                            Previous
                          </button>
                          <span className="flex items-center text-xs text-gray-600 px-2 font-medium">
                            Page {attendancePage} of {totalAttendancePages}
                          </span>
                          <button
                            onClick={() => setAttendancePage(p => Math.min(p + 1, totalAttendancePages))}
                            disabled={attendancePage === totalAttendancePages}
                            className="px-3.5 py-1.5 border border-gray-300 rounded-lg text-xs font-semibold text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200"
                          >
                            Next
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                )}


                {/* Applications Tab */}
                {activeTab === 'applications' && (
                  <div className="bg-white rounded-xl shadow-sm border">
                    <div className="px-6 py-4 border-b">
                      <h2 className="text-lg font-semibold text-gray-800">
                        Job Applications
                      </h2>
                    </div>

                    <div className="overflow-x-auto">
                      <table className="min-w-full text-sm">
                        <thead className="bg-gray-50 text-gray-500 uppercase text-xs">
                          <tr>
                            <th className="px-6 py-3 text-left">Candidate</th>
                            <th className="px-6 py-3 text-left">Position</th>
                            <th className="px-6 py-3 text-left">Experience</th>
                            <th className="px-6 py-3 text-left">Contact Info</th>
                            <th className="px-6 py-3 text-left">Status</th>
                            <th className="px-6 py-3 text-left">Resume</th>
                            <th className="px-6 py-3 text-left">Actions</th>
                          </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-200">
                          {applications.length === 0 ? (
                            <tr>
                              <td colSpan={7} className="px-6 py-10 text-center text-gray-400">
                                No job applications received yet
                              </td>
                            </tr>
                          ) : (
                            applications.map((app) => (
                              <tr key={app.id} className="hover:bg-gray-50">
                                <td className="px-6 py-4 font-semibold text-brand-secondary">
                                  <div>{app.full_name}</div>
                                  {app.location && <div className="text-[10px] text-gray-400 font-normal">📍 {app.location}</div>}
                                </td>
                                <td className="px-6 py-4 text-gray-600 font-medium">
                                  {app.job_title || app.position_applied || `Job ID: ${app.job_id}`}
                                </td>
                                <td className="px-6 py-4 text-gray-600">
                                  {app.experience_years} Years
                                </td>
                                <td className="px-6 py-4 text-gray-500 space-y-1">
                                  <div className="text-[11px]">{app.email}</div>
                                  <div className="text-[11px]">{app.phone}</div>
                                </td>
                                <td className="px-6 py-4">
                                  <span className={`px-2 py-1 rounded-full text-xs font-semibold uppercase tracking-wider ${
                                    app.status === 'new' ? 'bg-blue-100 text-blue-800' :
                                    app.status === 'shortlisted' ? 'bg-green-100 text-green-800' :
                                    app.status === 'rejected' ? 'bg-red-100 text-red-800' :
                                    'bg-gray-100 text-gray-800'
                                  }`}>
                                    {app.status}
                                  </span>
                                </td>
                                <td className="px-6 py-4">
                                  {app.resume_url ? (
                                    <a
                                      href={app.resume_url}
                                      target="_blank"
                                      rel="noreferrer"
                                      className="flex items-center text-xs font-semibold text-brand-primary hover:underline"
                                    >
                                      <Download className="h-4 w-4 mr-1" />
                                      Resume
                                    </a>
                                  ) : (
                                    <span className="text-gray-400 text-xs">No File</span>
                                  )}
                                </td>
                                <td className="px-6 py-4">
                                  <button
                                    onClick={() => {
                                      setSelectedApplication(app);
                                      setShowApplicationModal(true);
                                    }}
                                    className="flex items-center text-xs font-semibold text-brand-primary hover:text-brand-dark transition-colors duration-200"
                                  >
                                    <Eye className="h-4 w-4 mr-1" />
                                    View Details
                                  </button>
                                </td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}


                {/* Inquiries Tab */}
                {activeTab === 'inquiries' && (
                  <div className="bg-white rounded-xl shadow-sm border">
                    <div className="px-6 py-4 border-b">
                      <h2 className="text-lg font-semibold text-gray-800">
                        Contact Inquiries
                      </h2>
                    </div>

                    <div className="overflow-x-auto">
                      <table className="min-w-full text-sm">
                        <thead className="bg-gray-50 text-gray-500 uppercase text-xs">
                          <tr>
                            <th className="px-6 py-3 text-left">Name</th>
                            <th className="px-6 py-3 text-left">Email</th>
                            <th className="px-6 py-3 text-left">Company</th>
                            <th className="px-6 py-3 text-left">Mobile</th>
                            <th className="px-6 py-3 text-left">Subject</th>
                            <th className="px-6 py-3 text-left">Status</th>
                            <th className="px-6 py-3 text-left">Date</th>
                            <th className="px-6 py-3 text-left">Actions</th>
                          </tr>
                        </thead>

                        <tbody className="divide-y">
                          {inquiries.length === 0 ? (
                            <tr>
                              <td
                                colSpan={8}
                                className="px-6 py-10 text-center text-gray-400"
                              >
                                No inquiries found
                              </td>
                            </tr>
                          ) : (
                            inquiries.map((inquiry) => (
                              <tr key={inquiry.id} className="hover:bg-gray-50">
                                <td className="px-6 py-4 font-semibold text-brand-secondary">
                                  {inquiry.name}
                                </td>
                                <td className="px-6 py-4 text-gray-600">
                                  {inquiry.email}
                                </td>
                                <td className="px-6 py-4 text-gray-600">
                                  {inquiry.company || '-'}
                                </td>
                                <td className="px-6 py-4 text-gray-600">
                                  {inquiry.phone || '-'}
                                </td>
                                <td className="px-6 py-4 text-gray-600">
                                  {inquiry.subject}
                                </td>
                                <td className="px-6 py-4">
                                  <span className="px-2 py-1 rounded-full text-xs bg-blue-100 text-blue-700">
                                    {inquiry.status}
                                  </span>
                                </td>
                                <td className="px-6 py-4 text-gray-500">
                                  {new Date(inquiry.created_at).toLocaleDateString()}
                                </td>
                                <td className="px-6 py-4">
                                  <button
                                    onClick={() => {
                                      setSelectedInquiry(inquiry);
                                      setShowInquiryModal(true);
                                    }}
                                    className="flex items-center text-xs font-semibold text-brand-primary hover:text-brand-dark transition-colors duration-200"
                                  >
                                    <Eye className="h-4 w-4 mr-1" />
                                    View Details
                                  </button>
                                </td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}
                {activeTab === 'crm' && (
                  <div className="space-y-6">
                    <div className="bg-white rounded-xl shadow-sm border p-6">
                      <h2 className="text-lg font-bold text-gray-800 mb-2">
                        Sales & Lead Pipeline CRM
                      </h2>
                      <p className="text-sm text-gray-500 font-medium">
                        Track and manage your client inquiries from initial contact to contract signing. Click arrows or select dropdowns on each lead card to transition stages.
                      </p>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
                      {[
                        { key: 'new', label: 'New Leads', color: 'bg-blue-50 border-blue-200 text-blue-800' },
                        { key: 'contacted', label: 'Contacted / Follow-up', color: 'bg-yellow-50 border-yellow-200 text-yellow-800' },
                        { key: 'proposal', label: 'Proposal Sent', color: 'bg-purple-50 border-purple-200 text-purple-800' },
                        { key: 'signed', label: 'Closed Won / Signed', color: 'bg-green-50 border-green-200 text-green-800' }
                      ].map((column) => {
                        const columnLeads = inquiries.filter(
                          (lead) => (lead.status || 'new').toLowerCase() === column.key
                        );
                        return (
                          <div key={column.key} className="bg-gray-100 rounded-xl p-4 flex flex-col min-h-[500px] border">
                            <div className="flex items-center justify-between mb-4 pb-2 border-b border-gray-200">
                              <span className={`px-2.5 py-1 rounded-full text-xs font-bold ${column.color}`}>
                                {column.label}
                              </span>
                              <span className="text-xs font-bold text-gray-500 bg-white px-2 py-0.5 rounded-full shadow-sm">
                                {columnLeads.length}
                              </span>
                            </div>

                            <div className="flex-1 space-y-3 overflow-y-auto max-h-[600px] pr-1">
                              {columnLeads.length === 0 ? (
                                <div className="text-center py-10 text-gray-400 text-xs italic border border-gray-200 border-dashed rounded-lg bg-white/50">
                                  No leads in this stage
                                </div>
                              ) : (
                                columnLeads.map((lead) => (
                                  <div
                                    key={lead.id}
                                    className="bg-white p-4 rounded-lg shadow-sm border hover:shadow-md transition-all duration-200 space-y-3 relative group"
                                  >
                                    <div>
                                      <h4 className="font-semibold text-sm text-brand-secondary">
                                        {lead.name}
                                      </h4>
                                      <p className="text-xs text-gray-500 font-medium">
                                        {lead.company || 'Individual client'}
                                      </p>
                                    </div>

                                    <div className="space-y-1 text-xs text-gray-600 border-t pt-2">
                                      <div className="flex items-center gap-1.5">
                                        <Mail className="h-3 w-3 text-gray-400" />
                                        <span className="truncate">{lead.email}</span>
                                      </div>
                                      {lead.phone && (
                                        <div className="flex items-center gap-1.5">
                                          <MapPin className="h-3 w-3 text-gray-400" />
                                          <span>{lead.phone}</span>
                                        </div>
                                      )}
                                      <div className="font-semibold text-brand-primary mt-1">
                                        Subj: {lead.subject}
                                      </div>
                                    </div>

                                    <div className="border-t pt-2 flex items-center justify-between gap-2">
                                      <button
                                        onClick={() => {
                                          setSelectedInquiry(lead);
                                          setShowInquiryModal(true);
                                        }}
                                        className="text-xs text-gray-500 hover:text-brand-primary font-semibold flex items-center gap-1"
                                      >
                                        <Eye className="h-3.5 w-3.5" />
                                        View
                                      </button>

                                      <select
                                        value={lead.status || 'new'}
                                        onChange={async (e) => {
                                          const newStatus = e.target.value;
                                          try {
                                            const res = await dbHelpers.updateInquiryStatus(lead.id, newStatus);
                                            if (res.status) {
                                              await loadData();
                                            } else {
                                              alert(res.message || 'Failed to update stage');
                                            }
                                          } catch (err) {
                                            console.error(err);
                                            alert('Error updating CRM pipeline stage');
                                          }
                                        }}
                                        className="text-xs bg-gray-50 border rounded px-1.5 py-0.5 font-medium text-gray-600 focus:outline-none focus:ring-1 focus:ring-brand-primary cursor-pointer"
                                      >
                                        <option value="new">New Lead</option>
                                        <option value="contacted">Contacted</option>
                                        <option value="proposal">Proposal</option>
                                        <option value="signed">Signed</option>
                                      </select>
                                    </div>
                                  </div>
                                ))
                              )}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}

                {activeTab === 'marketing' && (
                  <MarketingDashboard />
                )}

                {activeTab === 'billing' && (
                  <BillingManager currentUser={user} />
                )}
              </>
            )}
          </div>
        </div>



        {/* Employee Form Modal */}
        {showEmployeeForm && (
          /* <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
             <div className="bg-white rounded-xl max-w-md w-full">*/
          <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4">
            <div className="bg-white w-full max-w-lg md:max-w-2xl rounded-xl shadow-lg
                  max-h-[90vh] overflow-y-auto">
              <div className="p-6 border-b border-gray-200">
                <div className="flex items-center justify-between">
                  <h2 className="text-2xl font-bold text-brand-secondary">
                    {editingEmployee ? 'Edit Employee' : 'Add New Employee'}
                  </h2>
                  <button
                    onClick={() => {
                      setShowEmployeeForm(false);
                      setEditingEmployee(null);
                      resetEmployeeForm();
                    }}
                    className="text-gray-500 hover:text-gray-700"
                  >
                    <X className="h-6 w-6" />
                  </button>
                </div>
              </div>

              <form onSubmit={editingEmployee ? handleUpdateEmployee : handleCreateEmployee} className="p-6 space-y-2">
                <div>
                  <label className="block text-sm font-medium text-brand-secondary mb-2">Full Name</label>
                  <input
                    type="text"
                    value={employeeForm.name}
                    onChange={(e) => setEmployeeForm(prev => ({ ...prev, name: e.target.value }))}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-primary focus:border-transparent"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-brand-secondary mb-2">Email</label>
                  <input
                    type="email"
                    value={employeeForm.email}
                    onChange={(e) => setEmployeeForm(prev => ({ ...prev, email: e.target.value }))}
                    required
                    disabled={!!editingEmployee}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-primary focus:border-transparent disabled:bg-gray-100"
                  />
                </div>

                {!editingEmployee && (
                  <div>
                    <label className="block text-sm font-medium text-brand-secondary mb-2">Password</label>
                    <input
                      type="password"
                      value={employeeForm.password}
                      onChange={(e) => setEmployeeForm(prev => ({ ...prev, password: e.target.value }))}
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-primary focus:border-transparent"
                    />
                  </div>
                )}

                <div>
                  <label className="block text-sm font-medium text-brand-secondary mb-2">Role</label>
                  <select
                    value={employeeForm.role}
                    onChange={(e) => setEmployeeForm(prev => ({ ...prev, role: e.target.value as any }))}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-primary focus:border-transparent"
                  >
                    <option value="employee">Employee</option>
                    <option value="hr">HR</option>
                    <option value="sales">Sales Team</option>
                    <option value="marketing">Marketing Team</option>
                    <option value="finance">Finance</option>
                    <option value="product_manager">Product Manager</option>
                    <option value="scrum_master">Scrum Master</option>
                    <option value="client">Client</option>
                    <option value="admin">Admin</option>
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-brand-secondary mb-2">Department</label>
                  <select
                    value={employeeForm.department}
                    onChange={(e) => setEmployeeForm(prev => ({ ...prev, department: e.target.value }))}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-primary focus:border-transparent"
                  >
                    <option value="">Select Department</option>
                    <option value="Engineering">Engineering</option>
                    <option value="Design">Design</option>
                    <option value="Analytics">Analytics</option>
                    <option value="Infrastructure">Infrastructure</option>
                    <option value="Security">Security</option>
                    <option value="Sales">Sales</option>
                    <option value="Marketing">Marketing</option>
                    <option value="Human Resources">Human Resources</option>
                    <option value="Management">Management</option>
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-brand-secondary mb-2">Join Date</label>
                  <input
                    type="date"
                    value={employeeForm.joinDate}
                    onChange={(e) => setEmployeeForm(prev => ({ ...prev, joinDate: e.target.value }))}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-primary focus:border-transparent"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-brand-secondary mb-2">Status</label>
                  <div className="flex items-center space-x-4">
                    <label className="flex items-center">
                      <input
                        type="radio"
                        name="isActive"
                        checked={employeeForm.isActive}
                        onChange={() => setEmployeeForm(prev => ({ ...prev, isActive: true }))}
                        className="mr-2"
                      />
                      Active
                    </label>
                    <label className="flex items-center">
                      <input
                        type="radio"
                        name="isActive"
                        checked={!employeeForm.isActive}
                        onChange={() => setEmployeeForm(prev => ({ ...prev, isActive: false }))}
                        className="mr-2"
                      />
                      Inactive
                    </label>
                  </div>
                </div>

                <div className="flex gap-4 pt-4">
                  <button
                    type="submit"
                    className="flex-1 bg-brand-primary text-white py-3 px-6 rounded-lg font-semibold hover:bg-brand-dark transition-colors duration-200"
                  >
                    {editingEmployee ? 'Update Employee' : 'Create Employee'}
                  </button>
                  <button
                    type="button"
                    onClick={() => {
                      setShowEmployeeForm(false);
                      setEditingEmployee(null);
                      resetEmployeeForm();
                    }}
                    className="px-6 py-3 border border-gray-300 text-gray-700 rounded-lg font-medium hover:bg-gray-50 transition-colors duration-200"
                  >
                    Cancel
                  </button>
                </div>
              </form>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4"></div>
            </div>
          </div>
        )}

        {/* Job Form Modal */}
        {showJobForm && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
              <div className="p-6 border-b border-gray-200">
                <div className="flex items-center justify-between">
                  <h2 className="text-2xl font-bold text-brand-secondary">
                    {editingJob ? 'Edit Job Posting' : 'Add New Job Posting'}
                  </h2>
                  <button
                    onClick={() => {
                      setShowJobForm(false);
                      setEditingJob(null);
                      resetJobForm();
                    }}
                    className="text-gray-500 hover:text-gray-700"
                  >
                    <X className="h-6 w-6" />
                  </button>
                </div>
              </div>

              <form onSubmit={editingJob ? handleUpdateJob : handleCreateJob} className="p-6 space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-medium text-brand-secondary mb-2">Job Title</label>
                    <input
                      type="text"
                      value={jobForm.title}
                      onChange={(e) => setJobForm(prev => ({ ...prev, title: e.target.value }))}
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-primary focus:border-transparent"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-brand-secondary mb-2">Department</label>
                    <select
                      value={jobForm.department}
                      onChange={(e) => setJobForm(prev => ({ ...prev, department: e.target.value }))}
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-primary focus:border-transparent"
                    >
                      <option value="">Select Department</option>
                      <option value="Engineering">Engineering</option>
                      <option value="Design">Design</option>
                      <option value="Analytics">Analytics</option>
                      <option value="Infrastructure">Infrastructure</option>
                      <option value="Security">Security</option>
                      <option value="Sales">Sales</option>
                      <option value="Marketing">Marketing</option>
                      <option value="HR">HR</option>
                    </select>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-brand-secondary mb-2">Location</label>
                    <input
                      type="text"
                      value={jobForm.location}
                      onChange={(e) => setJobForm(prev => ({ ...prev, location: e.target.value }))}
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-primary focus:border-transparent"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-brand-secondary mb-2">Job Type</label>
                    <select
                      value={jobForm.type}
                      onChange={(e) => setJobForm(prev => ({ ...prev, type: e.target.value }))}
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-primary focus:border-transparent"
                    >
                      <option value="Full-time">Full-time</option>
                      <option value="Part-time">Part-time</option>
                      <option value="Contract">Contract</option>
                      <option value="Internship">Internship</option>
                    </select>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-brand-secondary mb-2">Experience Required</label>
                    <input
                      type="text"
                      value={jobForm.experience}
                      onChange={(e) => setJobForm(prev => ({ ...prev, experience: e.target.value }))}
                      required
                      placeholder="e.g., 3-5 years"
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-primary focus:border-transparent"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-brand-secondary mb-2">Salary Range</label>
                    <input
                      type="text"
                      value={jobForm.salary}
                      onChange={(e) => setJobForm(prev => ({ ...prev, salary: e.target.value }))}
                      required
                      placeholder="e.g., ₹12-20 LPA"
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-primary focus:border-transparent"
                    />
                  </div>
                  <div className="md:col-span-2">
                    <label className="block text-sm font-medium text-brand-secondary mb-2">Application Deadline</label>
                    <input
                      type="date"
                      value={jobForm.applicationDeadline}
                      onChange={(e) => setJobForm(prev => ({ ...prev, applicationDeadline: e.target.value }))}
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-primary focus:border-transparent"
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-brand-secondary mb-2">Required Skills (comma-separated)</label>
                  <input
                    type="text"
                    value={jobForm.skills}
                    onChange={(e) => setJobForm(prev => ({ ...prev, skills: e.target.value }))}
                    placeholder="e.g., React, Node.js, MongoDB, AWS"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-primary focus:border-transparent"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-brand-secondary mb-2">Job Description</label>
                  <textarea
                    value={jobForm.description}
                    onChange={(e) => setJobForm(prev => ({ ...prev, description: e.target.value }))}
                    required
                    rows={4}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-primary focus:border-transparent resize-vertical"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-brand-secondary mb-2">Requirements (one per line)</label>
                  <textarea
                    value={jobForm.requirements}
                    onChange={(e) => setJobForm(prev => ({ ...prev, requirements: e.target.value }))}
                    rows={5}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-primary focus:border-transparent resize-vertical"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-brand-secondary mb-2">Responsibilities (one per line)</label>
                  <textarea
                    value={jobForm.responsibilities}
                    onChange={(e) => setJobForm(prev => ({ ...prev, responsibilities: e.target.value }))}
                    rows={5}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-primary focus:border-transparent resize-vertical"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-brand-secondary mb-2">Benefits (one per line)</label>
                  <textarea
                    value={jobForm.benefits}
                    onChange={(e) => setJobForm(prev => ({ ...prev, benefits: e.target.value }))}
                    rows={4}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-primary focus:border-transparent resize-vertical"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-brand-secondary mb-2">Status</label>
                  <div className="flex items-center space-x-4">
                    <label className="flex items-center">
                      <input
                        type="radio"
                        name="isActive"
                        checked={jobForm.isActive}
                        onChange={() => setJobForm(prev => ({ ...prev, isActive: true }))}
                        className="mr-2"
                      />
                      Active
                    </label>
                    <label className="flex items-center">
                      <input
                        type="radio"
                        name="isActive"
                        checked={!jobForm.isActive}
                        onChange={() => setJobForm(prev => ({ ...prev, isActive: false }))}
                        className="mr-2"
                      />
                      Inactive
                    </label>
                  </div>
                </div>

                <div className="flex gap-4">
                  <button
                    type="submit"
                    className="flex-1 bg-brand-primary text-white py-3 px-6 rounded-lg font-semibold hover:bg-brand-dark transition-colors duration-200"
                  >
                    {editingJob ? 'Update Job' : 'Create Job'}
                  </button>
                  <button
                    type="button"
                    onClick={() => {
                      setShowJobForm(false);
                      setEditingJob(null);
                      resetJobForm();
                    }}
                    className="px-6 py-3 border border-gray-300 text-gray-700 rounded-lg font-medium hover:bg-gray-50 transition-colors duration-200"
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
        {/* Attendance Detail Modal */}
        {showAttendanceModal && (
          <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4">
            <div className="bg-white w-full max-w-4xl rounded-xl shadow-lg max-h-[90vh] flex flex-col">
              <div className="p-6 border-b border-gray-200 flex items-center justify-between">
                <div>
                  <h2 className="text-2xl font-bold text-brand-secondary">
                    Attendance History
                  </h2>
                  <p className="text-gray-500">Employee: {selectedUserName}</p>
                </div>
                <button
                  onClick={() => setShowAttendanceModal(false)}
                  className="text-gray-500 hover:text-gray-700 p-2 rounded-full hover:bg-gray-100"
                >
                  <X className="h-6 w-6" />
                </button>
              </div>

              <div className="flex-1 overflow-y-auto p-6">
                {attendanceLoading ? (
                  <div className="flex flex-col items-center justify-center py-12">
                    <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-brand-primary mb-4"></div>
                    <p className="text-gray-500">Fetching records...</p>
                  </div>
                ) : selectedUserAttendance.length === 0 ? (
                  <div className="text-center py-12 text-gray-400">
                    No attendance history found for this user.
                  </div>
                ) : (
                  <div className="overflow-x-auto">
                    <table className="w-full text-sm">
                      <thead className="bg-gray-50">
                        <tr className="border-b">
                          <th className="py-3 px-4 text-left font-semibold">Date</th>
                          <th className="py-3 px-4 text-left font-semibold">Check In</th>
                          <th className="py-3 px-4 text-left font-semibold">Check Out</th>
                          <th className="py-3 px-4 text-left font-semibold">Status</th>
                          <th className="py-3 px-4 text-left font-semibold">Working</th>
                          <th className="py-3 px-4 text-left font-semibold">Location</th>
                        </tr>
                      </thead>
                      <tbody>
                        {selectedUserAttendance.map((rec, idx) => (
                          <tr key={rec.id || idx} className="border-b hover:bg-gray-50">
                            <td className="py-3 px-4 font-medium whitespace-nowrap">
                              {new Date(rec.date).toLocaleDateString(undefined, {
                                weekday: 'short',
                                year: 'numeric',
                                month: 'short',
                                day: 'numeric'
                              })}
                            </td>
                            <td className="py-3 px-4 text-green-600 font-medium">
                              {rec.checkIn || rec.check_in || "-"}
                            </td>
                            <td className="py-3 px-4 text-blue-600 font-medium">
                              {rec.checkOut || rec.check_out || "-"}
                            </td>
                            <td className="py-3 px-4">
                              <span className={`px-2 py-1 rounded-full text-xs font-semibold ${rec.status === 'late' ? 'bg-red-100 text-red-700' : 'bg-green-100 text-green-700'
                                }`}>
                                {rec.status}
                              </span>
                            </td>
                            <td className="py-3 px-4 capitalize">
                              {rec.workingStatus || rec.working_status}
                            </td>
                            <td className="py-3 px-4">
                              <div className="flex flex-col text-[10px] text-gray-500">
                                <span className="truncate max-w-[150px]" title={rec.location?.checkInLocation}>
                                  In: {rec.location?.checkInLocation || 'N/A'}
                                </span>
                                <span className="truncate max-w-[150px]" title={rec.location?.checkOutLocation}>
                                  Out: {rec.location?.checkOutLocation || 'N/A'}
                                </span>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>

              <div className="p-6 border-t bg-gray-50 rounded-b-xl flex justify-end">
                <button
                  onClick={() => setShowAttendanceModal(false)}
                  className="px-6 py-2 bg-brand-primary text-white rounded-lg font-medium hover:bg-brand-dark transition-colors"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Application Detail Modal */}
        {showApplicationModal && selectedApplication && (
          <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4">
            <div className="bg-white w-full max-w-2xl rounded-xl shadow-lg max-h-[90vh] flex flex-col">
              <div className="p-6 border-b border-gray-200 flex items-center justify-between">
                <div>
                  <h2 className="text-2xl font-bold text-brand-secondary">
                    Candidate Profile Details
                  </h2>
                  <p className="text-gray-500 text-xs mt-1">Position: {selectedApplication.job_title || `Job ID: ${selectedApplication.job_id}`}</p>
                </div>
                <button
                  onClick={() => setShowApplicationModal(false)}
                  className="text-gray-500 hover:text-gray-700 p-2 rounded-full hover:bg-gray-100"
                >
                  <X className="h-6 w-6" />
                </button>
              </div>

              <div className="flex-1 overflow-y-auto p-6 space-y-6">
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <h4 className="text-xs font-bold text-gray-400 uppercase">Full Name</h4>
                    <p className="text-sm font-semibold text-brand-secondary mt-1">{selectedApplication.full_name}</p>
                  </div>
                  <div>
                    <h4 className="text-xs font-bold text-gray-400 uppercase">Experience</h4>
                    <p className="text-sm text-gray-700 mt-1">{selectedApplication.experience_years} Years</p>
                  </div>
                  <div>
                    <h4 className="text-xs font-bold text-gray-400 uppercase">Email Address</h4>
                    <p className="text-sm text-gray-700 mt-1">{selectedApplication.email}</p>
                  </div>
                  <div>
                    <h4 className="text-xs font-bold text-gray-400 uppercase">Phone Number</h4>
                    <p className="text-sm text-gray-700 mt-1">{selectedApplication.phone}</p>
                  </div>
                  <div>
                    <h4 className="text-xs font-bold text-gray-400 uppercase">Current Salary</h4>
                    <p className="text-sm text-gray-700 mt-1">₹{Number(selectedApplication.current_salary).toLocaleString()} / year</p>
                  </div>
                  <div>
                    <h4 className="text-xs font-bold text-gray-400 uppercase">Expected Salary</h4>
                    <p className="text-sm text-gray-700 mt-1">₹{Number(selectedApplication.expected_salary).toLocaleString()} / year</p>
                  </div>
                  <div>
                    <h4 className="text-xs font-bold text-gray-400 uppercase">Notice Period</h4>
                    <p className="text-sm text-gray-700 mt-1">{selectedApplication.notice_period || 'Immediate'}</p>
                  </div>
                  <div>
                    <h4 className="text-xs font-bold text-gray-400 uppercase">Submitted Date</h4>
                    <p className="text-sm text-gray-700 mt-1">{new Date(selectedApplication.submitted_at).toLocaleString()}</p>
                  </div>
                </div>

                <div>
                  <h4 className="text-xs font-bold text-gray-400 uppercase">Resume / CV Attachment</h4>
                  {selectedApplication.resume_url ? (
                    <a
                      href={selectedApplication.resume_url}
                      target="_blank"
                      rel="noreferrer"
                      className="inline-flex items-center text-xs font-semibold text-brand-primary hover:underline mt-1 bg-brand-light p-2 rounded-lg"
                    >
                      <Download className="h-4 w-4 mr-1" />
                      {selectedApplication.resume_name || 'Download Resume File'}
                    </a>
                  ) : (
                    <p className="text-sm text-gray-500 mt-1 italic">No resume uploaded</p>
                  )}
                </div>

                <div className="border-t pt-4">
                  <h4 className="text-xs font-bold text-gray-400 uppercase mb-2">Cover Letter / Speculative Inquiry</h4>
                  <div className="bg-gray-50 p-4 rounded-lg text-sm text-gray-700 whitespace-pre-line leading-relaxed max-h-48 overflow-y-auto">
                    {selectedApplication.cover_letter || 'No cover letter message provided.'}
                  </div>
                </div>
              </div>

              <div className="p-6 border-t bg-gray-50 rounded-b-xl flex justify-end">
                <button
                  onClick={() => setShowApplicationModal(false)}
                  className="px-6 py-2 bg-brand-primary text-white rounded-lg font-medium hover:bg-brand-dark transition-colors"
                >
                  Close Profile
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Inquiry Detail Modal */}
        {showInquiryModal && selectedInquiry && (
          <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4">
            <div className="bg-white w-full max-w-2xl rounded-xl shadow-lg max-h-[90vh] flex flex-col">
              <div className="p-6 border-b border-gray-200 flex items-center justify-between">
                <div>
                  <h2 className="text-2xl font-bold text-brand-secondary">
                    Project Inquiry Details
                  </h2>
                  <p className="text-gray-500 text-xs mt-1">Focus Area: {selectedInquiry.subject}</p>
                </div>
                <button
                  onClick={() => setShowInquiryModal(false)}
                  className="text-gray-500 hover:text-gray-700 p-2 rounded-full hover:bg-gray-100"
                >
                  <X className="h-6 w-6" />
                </button>
              </div>

              <div className="flex-1 overflow-y-auto p-6 space-y-6">
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <h4 className="text-xs font-bold text-gray-400 uppercase">Full Name</h4>
                    <p className="text-sm font-semibold text-brand-secondary mt-1">{selectedInquiry.name}</p>
                  </div>
                  <div>
                    <h4 className="text-xs font-bold text-gray-400 uppercase">Company Name</h4>
                    <p className="text-sm text-gray-700 mt-1">{selectedInquiry.company || 'Not specified'}</p>
                  </div>
                  <div>
                    <h4 className="text-xs font-bold text-gray-400 uppercase">Email Address</h4>
                    <p className="text-sm text-gray-700 mt-1">{selectedInquiry.email}</p>
                  </div>
                  <div>
                    <h4 className="text-xs font-bold text-gray-400 uppercase">Mobile Number</h4>
                    <p className="text-sm font-semibold text-brand-secondary mt-1">{selectedInquiry.phone || 'Not specified'}</p>
                  </div>
                  <div>
                    <h4 className="text-xs font-bold text-gray-400 uppercase">Submitted Date</h4>
                    <p className="text-sm text-gray-700 mt-1">{new Date(selectedInquiry.created_at).toLocaleString()}</p>
                  </div>
                </div>

                <div className="border-t pt-4">
                  <h4 className="text-xs font-bold text-gray-400 uppercase mb-2">Message / Requirements</h4>
                  <div className="bg-gray-50 p-4 rounded-lg text-sm text-gray-700 whitespace-pre-line leading-relaxed max-h-60 overflow-y-auto">
                    {selectedInquiry.message || 'No details provided.'}
                  </div>
                </div>
              </div>

              <div className="p-6 border-t bg-gray-50 rounded-b-xl flex justify-end">
                <button
                  onClick={() => setShowInquiryModal(false)}
                  className="px-6 py-2 bg-brand-primary text-white rounded-lg font-medium hover:bg-brand-dark transition-colors"
                >
                  Close Details
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminDashboard;